import styled from 'styled-components';

import { Button as BreweryButton } from '@xing-com/button';
import { TextButton } from '@xing-com/crate-lebenslauf-button';
import { mediaNavExtended } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceXL,
  xdlColorText,
  xdlColorDisabledStrong,
  xdlColorBorderSoft,
  xdlColorBackground,
  xdlColorFocussed,
} from '@xing-com/tokens';

export const StyledNavigation = styled.nav`
  position: fixed;
  top: 0;
  left: 270px;
  right: calc((50vw - var(--previewWidth)) / 2);
  display: none;
  align-items: center;
  justify-content: flex-end;
  background-color: ${xdlColorBackground};
  z-index: 3;
  height: 88px;

  @media ${mediaNavExtended} {
    display: flex;
  }
`;

export const StyledButton = styled(TextButton)<{
  $isFilled: boolean;
  $isActive: boolean;
}>`
  ${({ $isFilled, $isActive }) => `
    color: ${
      $isActive
        ? xdlColorFocussed
        : $isFilled
          ? xdlColorText
          : xdlColorDisabledStrong
    } !important;
    font-weight: ${$isFilled ? 'bold' : 'normal'};
  `}
  font-size: 12px;
  flex-shrink: 0;

  @media (min-width: 1500px) {
    font-size: 16px;
  }
`;

export const StyledHr = styled.hr<{
  $isFilled: boolean;
}>`
  height: 1px;
  width: 52px;
  display: inline-block;
  border: 0 none;
  margin: 0 ${spaceL};

  ${({ $isFilled }) => `
    background-color: ${$isFilled ? xdlColorText : xdlColorBorderSoft};
  `}

  @media (min-width: 1500px) {
    margin: 0 ${spaceXL};
    width: 74px;
  }
`;

export const StyledCVLink = styled(BreweryButton)`
  margin-left: ${spaceXL};

  @media (min-width: 1511px) {
    display: none;
  }
`;
